import { useContext, useMemo } from 'react'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { InspectionCacheContext } from '../DviCacheProvider/InspectionCacheProvider'
import { DviListProvider } from './DviListProvider'

export const DviListProviderCacheWrapper = ({
  children
}: {
  children: React.ReactNode
}) => {
  const { userId } = useAccessTokenAndShopId()
  const { inspections } = useContext(InspectionCacheContext)
  // include inspections that is assigned to the user and not finished yet
  const filteredInspections = useMemo(
    () =>
      inspections
        ?.filter(
          (i) =>
            i.inspection!.info!.tech === userId && !i.inspection!.info!.finished
        )
        .map((i) => i.inspection!),
    [inspections, userId]
  )

  return (
    <DviListProvider
      inspectionsRaw={filteredInspections}
      loadingInspections={!inspections}>
      {children}
    </DviListProvider>
  )
}
